import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import { type BaseUrl, toBaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { PLAN_TYPE } from '../../constants.tsx';
import type { PlansItemsResponse, PlansItems } from './types.tsx';

const handleError = (error: Error) => {
	throw error;
};

const transformResult = ({
	isVisible,
	staticLinks,
	recentPlans = [],
}: PlansItemsResponse): PlansItems => {
	const recentItems = recentPlans.map(({ planId, scenarioId, title, url }) => ({
		id: `${planId}|${scenarioId}`,
		title: title || '',
		url,
		type: PLAN_TYPE,
	}));

	return {
		isVisible,
		recent: recentItems,
		links: staticLinks,
	};
};

export const fetchPlansItems = async (baseUrl: BaseUrl = toBaseUrl('')): Promise<PlansItems> => {
	const url = `${baseUrl}/rest/jpo/1.0/navigation`;
	try {
		const response = await fetch(url, getDefaultOptions(url));

		if (response.ok) {
			const result: PlansItemsResponse = await response.json();
			return transformResult(result);
		}

		return handleError(new Error(response.statusText));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return handleError(error);
	}
};
